import { GlLink, GlModal, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { projectCommitsPath } from '~/lib/utils/path_helpers/repository';
import { encodeUrlHash } from '~/lib/utils/url_utility';
import { __, s__, sprintf } from '~/locale';
import CiIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/ci_icon/ci_icon.vue?vue3';
const SYMBOLIC_REF_PREFIX = /^refs\/(heads|tags)\//;
/**
 * Pipeline Stop Modal.
 *
 * Renders the modal used to confirm cancelling a pipeline.
 */ export default {
    name: 'PipelineStopModal',
    components: {
        GlModal,
        GlLink,
        GlSprintf,
        CiIcon
    },
    props: {
        pipeline: {
            type: Object,
            required: true,
            deep: true
        },
        showConfirmationModal: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'close-modal',
        'submit'
    ],
    computed: {
        pipelineId () {
            return getIdFromGraphQLId(this.pipeline.id);
        },
        refName () {
            const { ref, refPath } = this.pipeline;
            if (refPath) return refPath.replace(SYMBOLIC_REF_PREFIX, '');
            return ref;
        },
        refHref () {
            const { refUrl, project } = this.pipeline;
            if (refUrl) return refUrl;
            if (!this.refName || !project?.fullPath) return null;
            return encodeUrlHash(projectCommitsPath(project.fullPath, this.refName));
        },
        modalTitle () {
            return sprintf(s__('Pipeline|Stop pipeline #%{pipelineId}?'), {
                pipelineId: `${this.pipelineId}`
            }, false);
        },
        modalText () {
            return s__(`Pipeline|You're about to stop pipeline #%{pipelineId}.`);
        },
        primaryProps () {
            return {
                text: s__('Pipeline|Stop pipeline'),
                attributes: {
                    variant: 'danger'
                }
            };
        },
        showModal: {
            get () {
                return this.showConfirmationModal;
            },
            set () {
                this.$emit('close-modal');
            }
        }
    },
    methods: {
        emitSubmit (event) {
            this.$emit('submit', event);
        }
    },
    cancelProps: {
        text: __('Cancel')
    }
};
